import React, { useState, useEffect } from "react";
import { Row, Button, Image, Descriptions, Col } from "antd";
import GroupItem from "../../component/Desktop/groupItem";
import RowInput from "../../component/Desktop/rowInput";
import Loading from "../../component/Desktop/loading/loading";
import { KEY, lang } from "../../constants/common.const";
import API from "../../api/backend/officeDetail";
import BreakLine from "../../component/Desktop/breakLine";
import TitlePage from "../../component/Desktop/titlePage";
import BoxContent from "@src/component/Desktop/content";
import {
  isAdminOffice,
  isHeadOffice,
  MSG_CATCH,
  showMessage,
} from "../../constants/utils";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { RollbackOutlined, EditOutlined } from "@ant-design/icons";

import classDdl from "../../models/control/dropdownlist";
import classText from "../../models/control/text";
import { useSelector } from "react-redux";
import { checkRoleScreen } from "../../utils/roles";
import { useMediaQuery } from "react-responsive";
import { Layout, Avatar, Typography, Tabs, Card, Divider, Badge } from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  CopyOutlined,
  PaperClipOutlined,
} from "@ant-design/icons";

import {
  HomeOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  UserOutlined,
  FileTextOutlined,
  CodeOutlined,
  NumberOutlined,
} from "@ant-design/icons";
const { Title, Text } = Typography;

function ViewOffice({ isEndUser }) {
  let { id: modeEdit, id } = useParams();
  const history = useHistory();
  const { selectedFactory } = useSelector((state) => state.auth);
  const isPC = useMediaQuery({
    query: KEY.LAPTOP_WIDTH,
  });
  let [showLoading, setShowLoading] = useState(false);

  // Loading
  let openLoadingSpinner = () => {
    setShowLoading(true);
  };

  let closeLoadingSpinner = () => {
    setShowLoading(false);
  };

  // Group 1
  const [dataDetail, setDataDetail] = useState({});
  const [txtOfficeID, settxtOfficeID] = useState(new classText());
  const [txtTitle, settxtTitle] = useState(new classText());
  const [txtOfficeServer, settxtOfficeServer] = useState(new classDdl());
  const [txtNote, settxtNote] = useState(new classDdl());
  const [txtZipCode, settxtZipCode] = useState(new classText());
  const [txtAddress, settxtAddress] = useState(new classText());
  const [txtState, settxtState] = useState(new classText());
  const [ddlStatus, setddlStatus] = useState(new classText());
  const [txtEffectStartDate, settxtEffectStartDate] = useState(new classText());
  const [txtEffectEndDate, settxtEffectEndDate] = useState(new classText());
  const [imgAvatar, setimgAvatar] = useState(new classText());
  const [custormerApprove, setCustormerApprove] = useState(false);
  const [txtfactoryCode, setTxtFactoryCode] = useState(new classText());

  const listField = [
    {
      title: "事業所コード",
      value: txtOfficeID.value,
      icon: <CodeOutlined style={{ color: "#1890ff" }} />,
    },
    {
      title: "郵便番号",
      value: txtZipCode.value,
      icon: <NumberOutlined style={{ color: "#faad14" }} />,
    },
    {
      title: "住所",
      value: txtAddress.value,
      icon: <HomeOutlined style={{ color: "#52c41a" }} />,
    },
    {
      title: "都道府県名",
      value: txtState.value,
      icon: <EnvironmentOutlined style={{ color: "#eb2f96" }} />,
    },
    {
      title: lang.STATUS,
      value: ddlStatus.value,
      icon: (
        <Badge
          color={ddlStatus.value === "Active" ? "green" : "red"}
          text={ddlStatus.value}
        />
      ),
    },
    {
      title: "契約開始日",
      value: txtEffectStartDate.value,
      icon: <CalendarOutlined style={{ color: "#13c2c2" }} />,
    },
    {
      title: "契約終了日",
      value: txtEffectEndDate.value,
      icon: <CalendarOutlined style={{ color: "#cf1322" }} />,
    },
    {
      title: "事業所長",
      value: dataDetail.businessManagerName,
      icon: <UserOutlined style={{ color: "#722ed1" }} />,
    },
    {
      title: "副所長",
      value: dataDetail.depucityDirector1Name,
      icon: <UserOutlined style={{ color: "#2f54eb" }} />,
    },
    {
      title: "本社担当",
      value: dataDetail.headquartersChargeName,
      icon: <UserOutlined style={{ color: "#eb2f96" }} />,
    },
    {
      title: lang.CUSTORMER_APPROVE,
      value: custormerApprove ? lang.YES : lang.NO,
      icon: custormerApprove ? (
        <CheckCircleOutlined style={{ color: "green" }} />
      ) : (
        <CloseCircleOutlined style={{ color: "red" }} />
      ),
    },
    {
      title: "備考",
      value: txtNote.value,
      icon: <FileTextOutlined style={{ color: "#fa541c" }} />,
    },
  ];
  const renderFiledModeEndUser = listField.map((item, index) => {
    return (
      <Descriptions.Item
        span={2}
        key={index}
        label={item.title}
        labelStyle={{
          width: isPC ? "20%" : "30%",
          fontWeight: "bold",
          padding: "10px 16px",
          backgroundColor: "#f0f0f0",
          borderRadius: "4px 0 0 4px",
        }}
        contentStyle={{
          padding: "10px 16px",
          backgroundColor: "#ffffff",
          borderRadius: "0 4px 4px 0",
        }}
      >
        <Row align="middle">
          {item.icon && <Col style={{ marginRight: "10px" }}>{item.icon}</Col>}
          <Col>
            <Text
              style={{
                color: item.value ? "#000" : "#888",
                fontStyle: item.value ? "normal" : "italic",
              }}
            >
              {item.value || "-"}
            </Text>
          </Col>
        </Row>
      </Descriptions.Item>
    );
  });

  const renderViewDataModeEndUser = (
    <Row style={{ paddingTop: 0 }} gutter={[8, 8]}>
      <Col span={24}>
        <h1
          style={{ textAlign: "center", marginBottom: 20 }}
          className="bold white-space"
        >
          {txtTitle.value}
        </h1>
      </Col>
      <Col span={isPC ? 8 : 12}>
        <BoxContent>
          <div className="avatar">
            <img class="profile_img" src="/img/default.png" alt="student dp" />
          </div>
        </BoxContent>
      </Col>
      <Col span={isPC ? 16 : 12}>
        <BoxContent>
          <Descriptions
            size="small"
            column={2}
            bordered
            style={{ maxHeight: "720px", overflow: "auto" }}
          >
            {renderFiledModeEndUser}
          </Descriptions>
        </BoxContent>
      </Col>
    </Row>
  );

  // const renderViewDataModeEndUser1 = (
  //   <Row style={{ paddingTop: 0, justifyContent: "center", borderRadius: "50px" }} gutter={[8, 8]}>
  //       <Col span={12}>
  //       <BoxContent>
  //         <div className="avatar">
  //           <Image width={"100%"} src={imgAvatar.value || "/img/default.png"} />
  //         </div>
  //       </BoxContent>
  //     </Col>
  //     <Col span={24} style={{position: "relative", top: "-60px"}}>
  //       <h1
  //         style={{ textAlign: "center" }}
  //         className="bold white-space"
  //       >
  //         {txtTitle.value}
  //       </h1>
  //     </Col>

  //     <Col span={isPC ? 16 : 12}>
  //       <BoxContent>
  //         <Descriptions
  //           size="small"
  //           column={2}
  //           bordered
  //           style={{ height: "auto", overflow: "auto" }}
  //         >
  //           {renderFiledModeEndUser}
  //         </Descriptions>
  //       </BoxContent>
  //     </Col>
  //   </Row>
  // );

  const renderViewDataModeEndUser1 = (
    <>
      <Row style={{ padding: 0 }}>
        <Col span={12} md={8}>
          <Card>
            <div
              className="d-flex flex-column align-items-center text-center"
              style={{ display: "block" }}
            >
              <Image
                src={imgAvatar.value || "/img/default.png"}
                width={"60%"}
                height={"200px"}
                style={{
                  borderRadius: "50%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              />
              <div style={{ marginTop: "16px" }}>
                <Title level={4}> {txtTitle.value}</Title>
                <Text type="primary">
                  {" "}
                  <Badge
                    color={ddlStatus.value === "Active" ? "green" : "red"}
                    text={ddlStatus.value}
                  />
                </Text>
                <br />
                <Text
                  type="primary"
                  style={{ fontSize: "small", color: "#888" }}
                >
                  {txtAddress.value}
                </Text>
              </div>
            </div>
          </Card>
        </Col>
        <Col md={16} span={24}>
          <div class="card shadow-sm">
            <div class="card-header">
              <Card>
                <div style={{ marginBottom: "16px" }}>
                  <Row>
                    <Col span={6}>
                      <Title style={{ marginBottom: 0, fontSize: "15px" }}>
                        事業所コード
                      </Title>
                    </Col>
                    <Col span={18}>
                      <Text type="primary">{txtOfficeID.value}</Text>
                    </Col>
                  </Row>
                </div>
                <hr />
                <div style={{ marginBottom: "10px" }}>
                  <Row>
                    <Col span={6}>
                      <Title
                        level={6}
                        style={{ marginBottom: 0, fontSize: "15px" }}
                      >
                        郵便番号
                      </Title>
                    </Col>
                    <Col span={18}>
                      <Text type="primary">{txtZipCode.value}</Text>
                    </Col>
                  </Row>
                </div>
                <hr />
                <div style={{ marginBottom: "10px" }}>
                  <Row>
                    <Col span={6}>
                      <Title
                        level={6}
                        style={{ marginBottom: 0, fontSize: "15px" }}
                      >
                        都道府県名
                      </Title>
                    </Col>
                    <Col span={18}>
                      <Text type="primary">{txtState.value}</Text>
                    </Col>
                  </Row>
                </div>
                <hr />
                <div style={{ marginBottom: "10px" }}>
                  <Row>
                    <Col span={6}>
                      <Title
                        level={6}
                        style={{ marginBottom: 0, fontSize: "15px" }}
                      >
                        ステータス
                      </Title>
                    </Col>
                    <Col span={18}>
                      <Text type="primary">{ddlStatus.value}</Text>
                    </Col>
                  </Row>
                </div>
                <hr />

                <div style={{ marginBottom: "10px" }}>
                  <Row>
                    <Col span={6}>
                      <Title
                        level={6}
                        style={{ marginBottom: 0, fontSize: "15px" }}
                      >
                        契約開始日
                      </Title>
                    </Col>
                    <Col span={18}>
                      <Text type="primary">{txtEffectStartDate.value}</Text>
                    </Col>
                  </Row>
                </div>
                <hr />
                <div style={{ marginBottom: "10px" }}>
                  <Row>
                    <Col span={6}>
                      <Title
                        level={6}
                        style={{ marginBottom: 0, fontSize: "15px" }}
                      >
                        契約終了日
                      </Title>
                    </Col>
                    <Col span={18}>
                      <Text type="primary">{txtEffectEndDate.value}</Text>
                    </Col>
                  </Row>
                </div>
                <hr />
                <div style={{ marginBottom: "10px" }}>
                  <Row>
                    <Col span={6}>
                      <Title
                        level={6}
                        style={{ marginBottom: 0, fontSize: "15px" }}
                      >
                        事業所長
                      </Title>
                    </Col>
                    <Col span={18}>
                      <Text type="primary">
                        {dataDetail.depucityDirector1Name}
                      </Text>
                    </Col>
                  </Row>
                </div>
                <hr />
                <div style={{ marginBottom: "10px" }}>
                  <Row>
                    <Col span={6}>
                      <Title
                        level={6}
                        style={{ marginBottom: 0, fontSize: "15px" }}
                      >
                        本社担当
                      </Title>
                    </Col>
                    <Col span={18}>
                      <Text type="primary">
                        {dataDetail.headquartersChargeName}
                      </Text>
                    </Col>
                  </Row>
                </div>
                <hr />
                <div style={{ marginBottom: "10px" }}>
                  <Row>
                    <Col span={6}>
                      <Title
                        level={6}
                        style={{ marginBottom: 0, fontSize: "15px" }}
                      >
                        {lang.CUSTORMER_APPROVE}
                      </Title>
                    </Col>
                    <Col span={18}>
                      <Text type="primary">
                        {custormerApprove ? lang.YES : lang.NO}
                      </Text>
                    </Col>
                  </Row>
                </div>

                <hr />
                <div style={{ marginBottom: "10px" }}>
                  <Row>
                    <Col span={6}>
                      <Title
                        level={6}
                        style={{ marginBottom: 0, fontSize: "15px" }}
                      >
                        備考
                      </Title>
                    </Col>
                    <Col span={18}>
                      <Text type="primary">{txtNote.value}</Text>
                    </Col>
                  </Row>
                </div>
              </Card>
            </div>
          </div>
        </Col>

        {/* <Col span={isPC ? 16 : 12}>
        <BoxContent>
          <Descriptions
            size="small"
            column={2}
            bordered
            style={{ height: "auto", overflow: "auto" }}
          >
            {renderFiledModeEndUser}
          </Descriptions>
        </BoxContent>
      </Col> */}
      </Row>
    </>
  );

  const { allowRoute } = useSelector((state) => state.auth);
  const location = useLocation();
  const init = () => {
    // Open loading
    openLoadingSpinner();

    Promise.all([modeEdit ? API.getDetailByID(id) : API.getDetail()])
      .then((res) => {
        if (res[0] && !res[0].data && id) {
          history.push("/OfficeManagement");
          return;
        }
        let data = res[0] ? res[0].data : null;

        if (data) {
          setDataDetail(data);
          settxtOfficeID({ ...txtOfficeID, value: data.siteOfficeMasterCode });
          settxtTitle({ ...txtTitle, value: data.siteOfficeMasterName });
          settxtOfficeServer({ ...txtOfficeServer, value: data.officeServer }); // 事業所サーバー
          settxtNote({ ...txtNote, value: data.note });
          settxtZipCode({
            ...txtZipCode,
            value: data.zipCode1 + " - " + data.zipCode2,
          });
          settxtAddress({ ...txtAddress, value: data.address });
          settxtState({ ...txtState, value: data.prefectureName });
          setddlStatus({ ...ddlStatus, value: data.statusValue });
          settxtEffectStartDate({
            ...txtEffectStartDate,
            value: data.startDate,
          });
          settxtEffectEndDate({ ...txtEffectEndDate, value: data.endDate });
          setimgAvatar({ ...imgAvatar, value: data.imageUrl });
          setCustormerApprove(data.customerApprove);
          setTxtFactoryCode({ ...txtfactoryCode, value: data.factoryCode });
        } else {
          throw new Error();
        }
      })
      .catch((err) => {
        showMessage(KEY.ERROR, MSG_CATCH());
      })
      .then(() => {
        closeLoadingSpinner();
      });
  };

  // Init
  useEffect(() => {
    if (checkRoleScreen(location.pathname, allowRoute)) {
      init();
    }
  }, [allowRoute]);

  function backTo() {
    modeEdit ? history.goBack() : history.push("/OfficeDetail");
  }

  function onEdit() {
    history.push("/EditOffice");
  }

  return (
    <div className="des-content mt70">
      <Loading show={showLoading}></Loading>
      {!isEndUser ? (
        <>
          <TitlePage name={lang.OFFICE_DETAIL} />
          <GroupItem center>
            <div className="title-page d-block center mt0 mb0">
              <h1 className="bold white-space">{lang.OFFICE_DETAIL}</h1>
            </div>
            <div className="mt15"></div>
            {/* List item */}
            <BreakLine />
            <RowInput name="事業所コード" box>
              {txtOfficeID.value}
            </RowInput>
            <BreakLine />
            <RowInput name="事業所名" box>
              <div className="white-space">{txtTitle.value}</div>
            </RowInput>
            <BreakLine />
            {/* <RowInput name="事業所サーバー" box>
          {txtOfficeServer.value}
        </RowInput>
        <BreakLine /> */}

            <RowInput name="郵便番号" box>
              {txtZipCode.value}
            </RowInput>
            <BreakLine />
            <RowInput name={lang.FACTORY_CODE} box>
              {txtfactoryCode.value}
            </RowInput>
            <BreakLine />
            <RowInput name="住所" box>
              <div className="white-space">{txtAddress.value}</div>
            </RowInput>
            <BreakLine />
            <RowInput name="都道府県名" box>
              {txtState.value}
            </RowInput>
            <BreakLine />
            <RowInput name={lang.STATUS} box>
              {ddlStatus.value}
            </RowInput>
            <BreakLine />
            <RowInput name="契約開始日" box>
              {txtEffectStartDate.value}
            </RowInput>
            <BreakLine />
            <RowInput name="契約終了日" box>
              {txtEffectEndDate.value}
            </RowInput>
            <BreakLine />
            <RowInput name="事業所長" box>
              {dataDetail.businessManagerName}
            </RowInput>
            <BreakLine />
            <RowInput name="副所長" box>
              {dataDetail.depucityDirector1Name}
            </RowInput>
            <BreakLine />
            <RowInput name="本社担当" box>
              {dataDetail.headquartersChargeName}
            </RowInput>
            <BreakLine />
            <RowInput name="備考" box>
              <div className="white-space">{txtNote.value}</div>
            </RowInput>
            <BreakLine />
            <RowInput name={lang.CUSTORMER_APPROVE} box>
              <div className="white-space">
                {custormerApprove ? lang.YES : lang.NO}
              </div>
            </RowInput>
            <BreakLine />
            <RowInput name="写真" box>
              <Image
                style={{
                  maxWidth: "500px",
                  width: "auto",
                  maxHeight: "150px",
                }}
                src={imgAvatar.value}
              />
            </RowInput>
            <BreakLine />

            <Row justify="end" className="mt10">
              {(isAdminOffice() || (isHeadOffice() && !modeEdit)) &&
                !isEndUser && (
                  <Button
                    className="buttonPC button--info wAuto ml15"
                    onClick={onEdit}
                  >
                    <EditOutlined />
                    {lang.EDIT}
                  </Button>
                )}
              {!isEndUser && (
                <Button
                  className="buttonPC button--outline --todo-- wAuto ml15"
                  onClick={backTo}
                >
                  <RollbackOutlined />
                  {lang.BACK}
                </Button>
              )}
            </Row>
          </GroupItem>
        </>
      ) : (
        renderViewDataModeEndUser1
      )}
    </div>
  );
}

export default ViewOffice;
